import { ErrorManagement } from '@printdeal/error-management/react';
import { median } from 'es-toolkit';
import Api from '../Api';
import { FilterFacets } from '../../components/algolia-search/helper/algoliaFacets';

export type Question = {
  question: string;
  attribute: string;
  values: {
    value: string;
    count: number;
  }[];
  median: number;
};

export type Questions = {
  questions: Question[];
};

class ProductAiService extends Api {
  async getFacetFilteringQuestions(facets: FilterFacets): Promise<Questions> {
    try {
      const { data } = await this.httpClient.post<Questions>('/facet-questions', facets);

      // Add median property to each question and sort by median in descending order
      const processedQuestions = data.questions.map((question) => {
        const counts = question.values.map((v) => v.count);
        const calculatedMedian = counts.length > 0 ? median(counts) : 0;
        return {
          ...question,
          median: calculatedMedian,
        };
      }).sort((a, b) => b.median - a.median);
      return {
        questions: processedQuestions,
      };
    } catch (error) {
      ErrorManagement.exception({
        exception: error,
        fingerprint: ['ProductAiService-getFacetFilteringQuestions'],
        tags: {
          component: 'ProductAiService',
          fileLocation: 'services-product-ai-ProductAiService',
        },
      });
      return {
        questions: [],
      };
    }
  }
}

export default ProductAiService;
